module.exports = __webpack_public_path__ + "images/components/estimate_banners/link_with_image/products_right_sp_50f00cd73d2bb16ec9fe143fca1ae5f0.svg";